// get Order Detail By Id

import { toast } from "react-toastify";
import axiosClient from "../../axios-client";
export const GetItemOrderById = async (id) => {
  try {
    const response = await axiosClient.get(`item/OrderDetailById/${id}`);
    if (response.data.statusCode === 200) {
      return response.data.itemList;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw new Error("Error fetching questions");
  }
};
// get connections By Id

export const GetConnections = async (id) => {
  try {
    const response = await axiosClient.put(`message/FetchConnection/${id}`);
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      // throw new Error(response.data.message);
      toast.info(response.data.message);
    }
  } catch (error) {
    // throw new Error("Error fetching questions");
    toast.error("Error fetching connections");
  }
};
export const GetJobOffers = async (id) => {
  try {
    const response = await axiosClient.put(`message/ListJobOp/${id}`);
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      // throw new Error(response.data.message);
      toast.info(response.data.message);
    }
  } catch (error) {
    // throw new Error("Error fetching questions");
    toast.error("Error fetching connections");
  }
};
// api to post  new template
export const CreateNewTemplate = async (request) => {
  try {
    const response = await axiosClient.post(`message/messageTemplate`, request);
    if (response.data.statusCode === 200) {
      return response;
    } else {
      // throw new Error(response.data.msg);
      toast.error(response.data.msg);
    }
  } catch (error) {
    toast.error("Error adding new template");
  }
};
// api to Update template
export const updateTemplate = async (id, request) => {
  try {
    const response = await axiosClient.post(
      `message/messageTemplateUpdate/${id}`,
      request
    );
    if (response.data.statusCode === 200) {
      return response;
    } else {
      // throw new Error(response.data.msg);
      toast.error(response.data.msg);
    }
  } catch (error) {
    toast.error("Error update template");
  }
};

// Get all templates

export const GetAllTemplates = async () => {
  try {
    const response = await axiosClient.put(`message/ListAllMessageTemplate`);
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      toast.error(response.message);
    }
  } catch (error) {
    toast.error("Error fetching templates");
  }
};

export const GetImageSentListCustomer = async (id) => {
  try {
    const response = await axiosClient.get(
      `image/GetImageSentListCustomer/${id}`
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw new Error("Error fetching Images");
  }
};
export const UpdateImageStatus = async (id, request) => {
  try {
    const response = await axiosClient.put(`image/UpdateStatus/${id}`, request);
    if (response.data.statusCode === 200) {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (error) {
    toast.error("Error update template");
  }
};
export const UpdateImagePosition = async (request) => {
  try {
    const response = await axiosClient.put(`image/UpdatePosition`, request);
    if (response.data.statusCode === 200) {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (error) {
    toast.error("Error update poisition");
  }
};

// add img temp
export const AddImgTemplate = async (request) => {
  try {
    const response = await axiosClient.post(`image/addImage`, request);
    if (response.data.statusCode === 200) {
      return response;
    } else {
      toast.error(response.data.msg);
    }
  } catch (error) {
    toast.error("Error update template");
  }
};
// Add Oppertunity Inbox
export const oppertunityInbox = async (request) => {
  try {
    const response = await axiosClient.post(
      `message/OpportunityInbox`,
      request
    );
    if (response.data.statusCode === 200) {
      return response;
    } else {
      // throw new Error(response.data.msg);
      toast.error(response.data.msg);
    }
  } catch (error) {
    toast.error("Error to add Oppertunity Inbox");
  }
};
export const usersAdTypesApi = async (id) => {
  try {
    const response = await axiosClient.get(
      `services/ServiceCategoryNameByUser`
    );
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw new Error("Error fetching Images");
  }
};

export const orderInvoice = async (request) => {
  try {
    const response = await axiosClient.post(`order/OrderInvoice`, request);
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw new Error("Error fetching Images");
  }
};
// api to Send message
export const scheduleMessage = async (formData) => {
  try {
    const response = await axiosClient.post(
      `message/CreateScheduleMessage`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error Sending Message");
  }
};

export const getInvoicePay = async (Id) => {
  try {
    const response = await axiosClient.get(`/Order/getInvoicePay/${Id}`);
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get Invoice details");
  }
};

export const addGurudwaraNews = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/Gurudwara/addGurudwaraNews/`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to  Add Gurudwara News");
  }
};

export const updateGurudwaraNews = async (id, formData) => {
  try {
    const response = await axiosClient.put(
      `/Gurudwara/updateGurudwaraNews/${id}`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to Update Gurudwara News");
  }
};

export const getGurudwaraNewsList = async (formData) => {
  try {
    const response = await axiosClient.put(
      `/Gurudwara/getGurudwaraNewsList`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to fetch Gurudwara News");
  }
};
// get  all post
// export const GetAllPosts = async (Id) => {
//   try {
//     const response = await axiosClient.get(`Community/getCommunityList/${Id}`);
//     if (response.data.statusCode === 200) {
//       return response.data.Data;
//     } else {
//       toast.error(response.message);
//     }
//   } catch (error) {
//     toast.error("Error fetching getCommunityList");
//   }
// };
export const LikeThePost = async (formData) => {
  try {
    const response = await axiosClient.post(
      `Community/likeCommunityPost`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data;
    } else {
      toast.error(response.data.msg);
    }
  } catch (error) {
    toast.error("Error Liking Post");
  }
};
// comment on post
export const CommentOnPost = async (formData) => {
  try {
    const response = await axiosClient.post(
      `Community/AddCommunityComment`,
      formData
    );
    if (response.data.success) {
      return response.data.data;
    } else {
      toast.error(response.data.message);
    }
  } catch (error) {
    toast.error("Error Sending Comment");
  }
};

// get Likes
export const GetLikes = async (formData) => {
  try {
    const response = await axiosClient.put(
      `Community/countLikesByCommunityId`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      toast.error(response.data.msg);
    }
  } catch (error) {
    toast.error("Error to fetch Likes");
  }
};
// get All comments
export const GetAllComments = async (id) => {
  try {
    const response = await axiosClient.get(
      `Community/listCommunityComments?communityId=${id}`
    );
    if (response.data.success) {
      return response.data.data;
    } else {
      toast.error(response.message);
    }
  } catch (error) {
    toast.error("Error fetching get Community Comments");
  }
};

export const listInvoices = async (formData) => {
  try {
    const response = await axiosClient.put(`/order/listInvoices`, formData);
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to fetch Gurudwara News");
  }
};

export const createMessageMeeting = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/message/CreateMessageMeeting`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to fetch Gurudwara News");
  }
};

export const ListMessageMeeting = async (id) => {
  try {
    const response = await axiosClient.put(`/message/ListMessageMeeting/${id}`);
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to fetch Meeting List");
  }
};

export const updateInPerson = async (id, formData) => {
  try {
    const response = await axiosClient.put(
      `/message/updateInPersonMeeting/${id}`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to update In-Person Meeting");
  }
};

export const createReportIssue = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/message/CreateReportIssue/`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to Create a Report");
  }
};

export const ListReportIssues = async () => {
  try {
    const response = await axiosClient.get(`/message/ListReportIssues/`);
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to fetch Report List");
  }
};

export const UpdateReportStatus = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/message/UpdateReportStatus/`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to Update Report Status");
  }
};

export const listGotton = async (id, formData) => {
  try {
    const response = await axiosClient.put(`/need/listGotton/${id}`, formData);
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to fetch listGotton");
  }
};
export const createOrUpdateMessageSetting = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/message/createOrUpdateMessageSetting/`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to create Or Update Message Setting");
  }
};

export const listMessageSetting = async (id) => {
  try {
    const response = await axiosClient.put(`/message/listMessageSetting/${id}`);
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get listMessageSetting");
  }
};

export const updateMessageSettingStatus = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/message/updateMessageSettingStatus/`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get listMessageSetting");
  }
};

export const createGetCustomerSetting = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/services/createGetCustomerSetting/`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to create GetCustomerSetting");
  }
};

export const listCustomerInteractionsAdmin = async () => {
  try {
    const response = await axiosClient.get(
      `/services/listCustomerInteractionsAdmin/`
    );
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get customer Interaction List");
  }
};

export const listCustomerInteractionsVendor = async (Id) => {
  try {
    const response = await axiosClient.get(
      `/services/listCustomerInteractionsVendor/${Id}`
    );
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get customer Interaction List");
  }
};

export const logCustomerServiceView = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/services/logCustomerServiceView/`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to post log CustomerService View");
  }
};
export const listCustomerViewService = async (Id) => {
  try {
    const response = await axiosClient.get(
      `/services/listCustomerViewService/${Id}`
    );
    if (response.data.statusCode === 200) {
      return response.data.Data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get listCustomerViewService");
  }
};
export const createCallHistory = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/message/createCallHistory/`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to post Create Call History");
  }
};
export const getCallHistory = async (Id) => {
  try {
    const response = await axiosClient.put(`message/getCallHistory/${Id}`);
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get Call History");
  }
};

export const sendMessageList = async (Id) => {
  try {
    const response = await axiosClient.put(`message/sendMessageList/${Id}`);
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get send Message List");
  }
};

export const CustomerInitiatedUpdate = async (Id, formData) => {
  try {
    const response = await axiosClient.put(
      `/services/CustomerInitiatedUpdate/${Id}`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get Call History");
  }
};
export const createBookingNote = async (formData) => {
  try {
    const response = await axiosClient.post(
      `/Gurudwara/createBookingNote`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get Call History");
  }
};
export const fetchBookingNotes = async (Id) => {
  try {
    const response = await axiosClient.get(
      `/Gurudwara/fetchBookingNotes/${Id}`
    );
    if (response.data.statusCode === 200) {
      return response.data;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get Call History");
  }
};
export const bookingNote = async (Id, formData) => {
  try {
    const response = await axiosClient.delete(
      `/Gurudwara/booking-note/${Id}`,
      formData
    );
    if (response.data.statusCode === 200) {
      return response.message;
    } else {
      throw new Error(response.data.msg);
    }
  } catch (error) {
    throw new Error("Error to get Call History");
  }
};

export const compressVideo = async (file, options = {}) => {
  const {
    maxSizeMB = 0.5,
    maxDuration = 10000,
    maxDimension = 640,
    targetBitrate = 100000,
  } = options;

  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.src = URL.createObjectURL(file);
    video.preload = "metadata";
    video.muted = true;
    video.playsInline = true;

    video.onloadedmetadata = async () => {
      try {
        // Limit duration to maxDuration (in milliseconds)
        const duration = Math.min(video.duration * 1000, maxDuration);

        // Calculate resolution
        let width = video.videoWidth;
        let height = video.videoHeight;
        if (width > height) {
          if (width > maxDimension) {
            height = Math.round((height * maxDimension) / width);
            width = maxDimension;
          }
        } else {
          if (height > maxDimension) {
            width = Math.round((width * maxDimension) / height);
            height = maxDimension;
          }
        }

        // Set up canvas for frame capture
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");

        // Create a stream from the canvas
        const stream = canvas.captureStream(30); // 30 FPS

        // Create a video element to play the source video
        const tempVideo = document.createElement("video");
        tempVideo.src = video.src;
        tempVideo.muted = true;
        tempVideo.playsInline = true;

        // Start MediaRecorder with low bitrate for compression
        const recorder = new MediaRecorder(stream, {
          mimeType: "video/webm;codecs=vp8",
          videoBitsPerSecond: targetBitrate, // Target ~100kbps for significant compression
        });

        const chunks = [];
        recorder.ondataavailable = (event) => {
          if (event.data.size > 0) chunks.push(event.data);
        };

        recorder.onstop = async () => {
          const blob = new Blob(chunks, { type: "video/webm" });
          let compressedFile = new File(
            [blob],
            `compressed-${file.name.replace(/\.[^/.]+$/, "")}.webm`,
            { type: "video/webm" }
          );

          // Check if the compressed file size is within maxSizeMB
          const fileSizeMB = blob.size / (1024 * 1024);
          if (fileSizeMB > maxSizeMB) {
            // If still too large, retry with lower bitrate
            const newBitrate = Math.max(targetBitrate * 0.8, 50000); // Reduce bitrate by 20% but not below 50kbps
            if (newBitrate === 50000) {
              console.warn(
                "Reached minimum bitrate, returning current compression."
              );
              resolve(compressedFile);
            } else {
              URL.revokeObjectURL(video.src);
              tempVideo.pause();
              return resolve(
                compressVideo(file, { ...options, targetBitrate: newBitrate })
              );
            }
          }

          resolve(compressedFile);
          URL.revokeObjectURL(video.src);
          tempVideo.pause();
        };

        recorder.onerror = () => {
          reject(new Error("Error during video compression."));
          URL.revokeObjectURL(video.src);
          tempVideo.pause();
        };

        // Continuously draw video frames to canvas during playback
        let lastTime = 0;
        const drawFrame = (currentTime) => {
          if (
            !tempVideo.paused &&
            !tempVideo.ended &&
            currentTime - lastTime >= 1000 / 30
          ) {
            ctx.drawImage(tempVideo, 0, 0, width, height);
            lastTime = currentTime;
          }
          if (!tempVideo.paused && !tempVideo.ended) {
            requestAnimationFrame(drawFrame);
          }
        };

        // Start video playback and recording
        await tempVideo.play();
        requestAnimationFrame(drawFrame);
        recorder.start();

        // Stop after duration or when video ends
        tempVideo.onended = () => {
          recorder.stop();
        };
        setTimeout(() => {
          if (recorder.state === "recording") {
            recorder.stop();
          }
        }, duration);
      } catch (error) {
        reject(new Error(`Failed to compress video: ${error.message}`));
        URL.revokeObjectURL(video.src);
      }
    };

    video.onerror = () => {
      reject(new Error("Error loading video."));
      URL.revokeObjectURL(video.src);
    };
  });
};
